export type SlashCommandSource = "extension" | "prompt" | "skill";

export type SlashCommandLocation = "user" | "project" | "path";

export interface SlashCommandInfo {
	name: string;
	description?: string;
	source: SlashCommandSource;
	location?: SlashCommandLocation;
	path?: string;
}

export interface BuiltinSlashCommand {
	name: string;
	description: string;
}

export const BUILTIN_SLASH_COMMANDS: ReadonlyArray<BuiltinSlashCommand> = [
	{ name: "settings", description: "Open settings menu" },
	{ name: "model", description: "Select model (opens selector UI)" },
	{ name: "scoped-models", description: "Enable/disable models for Ctrl+P cycling" },
	{ name: "export", description: "Export session to HTML file" },
	{ name: "share", description: "Share session as a secret GitHub gist" },
	{ name: "copy", description: "Copy last agent message to clipboard" },
	{ name: "name", description: "Set session display name" },
	{ name: "session", description: "Show session info and stats" },
	{ name: "changelog", description: "Show changelog entries" },
	{ name: "hotkeys", description: "Show all keyboard shortcuts" },
	{ name: "fork", description: "Create a new fork from a previous message" },
	{ name: "tree", description: "Navigate session tree (switch branches)" },
	{ name: "login", description: "Login with OAuth provider" },
	{ name: "logout", description: "Logout from OAuth provider" },
	{ name: "new", description: "Start a new session" },
	{ name: "clear", description: "Clear terminal and start fresh session" },
	{ name: "compact", description: "Manually compact the session context" },
	{ name: "resume", description: "Resume a different session" },
	{ name: "reload", description: "Reload extensions, skills, prompts, and themes" },
	{ name: "init-project", description: "Scaffold a minimal project-local Jensen harness" },
	{ name: "protocol-status", description: "Show Jensen-Protocol workspace marker and context status" },
	{ name: "quit", description: "Quit Jensen" },
	{ name: "exit", description: "Exit Jensen" },
	{ name: "help", description: "Show startup help and loaded resources" },
	{ name: "doctor", description: "Run diagnostics and show system health" },
	{ name: "memory", description: "Inspect and manage active session memory" },
	{ name: "brief", description: "Enable, disable, or inspect runtime-only brief-only mode" },
	{ name: "caveman", description: "Enable Caveman output compression (lite, full, ultra, off, status)" },
	{ name: "btw", description: "Queue runtime-only by-the-way guidance for the next turn" },
	{ name: "steer", description: "Apply steering to the active workstream or resume from the latest assistant turn" },
	{ name: "ultraplan", description: "Run, show, revise, regenerate, or apply a persisted local-first planner plan" },
	{ name: "websearch", description: "Search the web using DuckDuckGo Lite" },
];
